import {
    JobSite, Customer, MakeModelFamily,
    Make, Model, Family, Side, ResultMessage
} from '../global/model'
import { equipmentVwMdl } from '../equipment/model';
import { Compart } from '../compart/model';
import { ActionType } from '../actions/model';

export class ComponentActionViewModel {
    public Id: number = 0;
    public ComponentId: number = 0;
    public ActionType: ActionType = ActionType.NoActionTakenYet;
    public Title: string = "";
    public Date: Date = new Date();
    public Side: number;
}

export class ComponentViewViewModel {
    public Id: number = 0;
    public EquipmentId: number = 0;
    public Compart: Compart = new Compart();
    public Side: Side = Side.Unknown;
    public Life: number = 0;
    public Date: Date = new Date();
    public Worn: number = 0;
    public Position: number = 0;
    public Actions: ComponentActionViewModel[] = [];
    public ProjectedHours: number;
    public Eval: string;
    public evalColor: string;
    public EqUnitId: number;
    public BushTurnLife: number;
    public BushTurnedPercent: number;
}

export class RecommendedActionsViewModel {
    public EquipmentId: number;
    public RecommendedActions: ComponentActionViewModel[];
    public CompletedActions: ComponentActionViewModel[];
}

export class InspectionViewModel {
    public Id: number = 0;
    public EquipmentId: number = 0;
    public Date: Date = new Date();
    public SMU: number = 0;
    public QuoteId: number = 0;
    public RecommendedActions: ComponentActionViewModel[] = [];
    public Inspector: string
}

export class EquipmentViewModel {
    public Id: number = 0;
    public Serial: string = "";
    public Unit: string = "";
    public Life: number = 0;
    public SMU: number = 0;
    public NextInspectionDate: Date;
    public NextInspectionSMU: number;
    public JobSite: JobSite = new JobSite();
    public Customer: Customer = new Customer();
    public MakeModelFamily: MakeModelFamily = new MakeModelFamily();
    public EquipmentPhoto: string;
    public SetupDate: Date;
    public DaysSinceLastInp: number;
    public TrackFrameSerialL: string;
    public TrackFrameSerialR: string;
    public TrackFrameCODateL: string;
    public TrackFrameCODateR: string;
    public TrackFrameCOSMUL: number;
    public TrackFrameCOSMUR: number;
    public TrackFrameLifeL: number;
    public TrackFrameLifeR: number;
    public TrackFrameHoursPercentL: number;
    public TrackFrameHoursPercentR: number;
    public TrackFrameBudgetLifeL: number;
    public TrackFrameBudgetLifeR: number;
    public MaxTrackRollers: number;
    public MaxCarrierRollers: number;
    public EqBarLife: number;
}

export class ComponentTableInspectionViewModel {
    public Id: number = 0;
    public Equipment: EquipmentViewModel = new EquipmentViewModel();
    public LastInspection: InspectionViewModel = new InspectionViewModel();
    public Components: ComponentViewViewModel[] = [];


    //new model

    public Serial: string;
    public Unit: string;
    public AddiUnit: string;
    public Model: string;
    public Site: string;
    public SMU: number;
    public LastInspDate: Date = new Date();
    public LastInspSMU: number = 0;
    public LinkL: string;
    public LinkR: string;
    public HoursLinkL: string;
    public HoursLinkR: string;
    public InstallDateLinkR: string;
    public InstallDateLinkL: string
    public BushL: string;
    public BushR: string;
    public HoursBushL: string;
    public HoursBushR: string;
    public InstallDateBushR: string;
    public InstallDateBushL: string
    public BushTurnBudgetL: string;
    public BushTurnBudgetR: string;
    public BushTurnL: string
    public BushTurnR: string
    public ShoeL: string;
    public ShoeR: string;
    public HoursShoeL: string;
    public HoursShoeR: string;
    public InstallDateShoeR: string;
    public InstallDateShoeL: string
    public FIdlerL: string
    public FIdlerR: string
    public HoursFIdlerL: string;
    public HoursFIdlerR: string;
    public InstallDateFIdlerL: string;
    public InstallDateFIdlerR: string
    public RIdlerL: string
    public RIdlerR: string
    public HoursRIdlerL: string;
    public HoursRIdlerR: string;
    public InstallDateRIdlerL: string;
    public InstallDateRIdlerR: string;
    public SprocketL: string
    public SprocketR: string
    public HoursSprocketL: string;
    public HoursSprocketR: string;
    public InstallDateSprocketL: string;
    public InstallDateSprocketR: string;
    public CRAvgL: string;
    public CRAvgR: string;
    public TRAvgL: string;
    public TRAvgR: string;
    public TRWorstL: string;
    public TRWorstR: string;
    public TRollerL: string;
    public TRollerR: string;
    public CRollerL: string;
    public CRollerR: string;

    public TrackEloL: string;
    public TrackEloR: string;
    public CarrierRoller1L: string
    public CarrierRoller1R: string
    public HoursCarrierRoller1L: string;
    public HoursCarrierRoller1R: string;
    public InstallDateCarrierRoller1L: string;
    public InstallDateCarrierRoller1R: string;

    public CarrierRoller2L: string
    public CarrierRoller2R: string
    public HoursCarrierRoller2L: string;
    public HoursCarrierRoller2R: string;
    public InstallDateCarrierRoller2L: string;
    public InstallDateCarrierRoller2R: string;

    public CarrierRoller3L: string
    public CarrierRoller3R: string
    public HoursCarrierRoller3L: string;
    public HoursCarrierRoller3R: string;
    public InstallDateCarrierRoller3L: string;
    public InstallDateCarrierRoller3R: string;

    public TrackRoller1L: string
    public TrackRoller1R: string
    public HoursTrackRoller1L: string;
    public HoursTrackRoller1R: string;
    public InstallDateTrackRoller1L: string;
    public InstallDateTrackRoller1R: string;

    public TrackRoller2L: string
    public TrackRoller2R: string
    public HoursTrackRoller2L: string;
    public HoursTrackRoller2R: string;
    public InstallDateTrackRoller2L: string;
    public InstallDateTrackRoller2R: string;

    public TrackRoller3L: string
    public TrackRoller3R: string
    public HoursTrackRoller3L: string;
    public HoursTrackRoller3R: string;
    public InstallDateTrackRoller3L: string;
    public InstallDateTrackRoller3R: string;

    public TrackRoller4L: string
    public TrackRoller4R: string
    public HoursTrackRoller4L: string;
    public HoursTrackRoller4R: string;
    public InstallDateTrackRoller4L: string;
    public InstallDateTrackRoller4R: string;

    public TrackRoller5L: string
    public TrackRoller5R: string
    public HoursTrackRoller5L: string;
    public HoursTrackRoller5R: string;
    public InstallDateTrackRoller5L: string;
    public InstallDateTrackRoller5R: string;

    public TrackRoller6L: string
    public TrackRoller6R: string
    public HoursTrackRoller6L: string;
    public HoursTrackRoller6R: string;
    public InstallDateTrackRoller6L: string;
    public InstallDateTrackRoller6R: string;

    public TrackRoller7L: string
    public TrackRoller7R: string
    public HoursTrackRoller7L: string;
    public HoursTrackRoller7R: string;
    public InstallDateTrackRoller7L: string;
    public InstallDateTrackRoller7R: string;

    public TrackRoller8L: string
    public TrackRoller8R: string
    public HoursTrackRoller8L: string;
    public HoursTrackRoller8R: string;
    public InstallDateTrackRoller8L: string;
    public InstallDateTrackRoller8R: string;

    public TrackRoller9L: string
    public TrackRoller9R: string
    public HoursTrackRoller9L: string;
    public HoursTrackRoller9R: string;
    public InstallDateTrackRoller9L: string;
    public InstallDateTrackRoller9R: string;

    public TrackRoller10L: string
    public TrackRoller10R: string
    public HoursTrackRoller10L: string;
    public HoursTrackRoller10R: string;
    public InstallDateTrackRoller10L: string;
    public InstallDateTrackRoller10R: string;
    //Wear NewModel

    public W_LinkL: string;
    public W_LinkR: string;
    public W_BushL: string;
    public W_BushR: string;
    public W_BushTurnBudgetL: string;
    public W_BushTurnBudgetR: string;
    public W_BushTurnL: string
    public W_BushTurnR: string
    public W_ShoeL: string;
    public W_ShoeR: string;
    public W_FIdlerL: string
    public W_FIdlerR: string
    public W_RIdlerL: string
    public W_RIdlerR: string
    public W_SprocketL: string
    public W_SprocketR: string

    public W_CR1L: string
    public W_CR1R: string
    public W_CR2L: string
    public W_CR2R: string
    public W_CR3L: string
    public W_CR3R: string
    public W_CR4L: string
    public W_CR4R: string
    public W_CR5L: string
    public W_CR5R: string

    public W_TR1L: string
    public W_TR1R: string
    public W_TR2L: string
    public W_TR2R: string
    public W_TR3L: string
    public W_TR3R: string
    public W_TR4L: string
    public W_TR4R: string
    public W_TR5L: string
    public W_TR5R: string


    public W_TR6L: string
    public W_TR6R: string
    public W_TR7L: string
    public W_TR7R: string
    public W_TR8L: string
    public W_TR8R: string
    public W_TR9L: string
    public W_TR9R: string
    public W_TR10L: string
    public W_TR10R: string

    public W_TR11L: string
    public W_TR11R: string
    public W_TR12L: string
    public W_TR12R: string
    public W_TR13L: string
    public W_TR13R: string
    public W_TR14L: string
    public W_TR14R: string
    public W_TR15L: string
    public W_TR15R: string

    public W_TrackElonL: string
    public W_TrackElonR: string

      public DaysSinceLastInsp: number;
      public TrackFrameSerialL: string;
      public TrackFrameSerialR: string;
      public TrackFrameBudgetLifeL: number;
      public TrackFrameBudgetLifeR: number;
      public TrackFrameLifeL: number;
      public TrackFrameLifeR: number;
      public TrackFrameCODateL: string;
      public TrackFrameCODateR: string;
      public TrackFrameCOSMUL: number;
      public TrackFrameCOSMUR: number;
      public EQBarLifeL: number;
      public EQBarLifeR: number;
}
export class ComponentViewResult {
    public ResultList: ComponentTableInspectionViewModel[] = [];
    public SearchResult: SearchResult = new SearchResult();
    public _clientReqId: number;
}
export class EquipmentViewResult {
    public ResultList: equipmentVwMdl[] = [];
    public SearchResult: SearchResult = new SearchResult();
    public _clientReqId: number;
}

export class SearchItemsParam {
    public SearchItems: SearchItem[] = [];
    public PageNo: number;
    public PageSize: number;
    public _clientReqId: number;
    public memberName: string;
    public sortName: string;
    public ascendingOrder: boolean;
    public typeId: number;
}

export class SearchItem {
    public Id: number = 0;
    public Title: string = "";
    public SearchId: number = 0;
    public SearchStr: string = "";
}

export class PrintItem {
    public HtmlText: string = "";
    public PrintId: number;
    public HtmlElement: string = "";
}

export class SearchResult {
    public Result: IdAndDate[] = [];
    public Total: number = 0;
}

export class IdAndDate {
    public Id: number = 0;
    public Date: Date = new Date();
}

export class SearchFavorite {
    public Id: number;
    public UserId: number;
    public Name: string = 'Example';
    public BackgroundColor: string = '#2F80ED';
    public TextColor: string = '#FFFFFF';
    public isDefaultFavourite: boolean
    public SearchItems: SearchItem[] = [];
    public ModuleId: number;
}
export enum FavOperation {
    Add = 1,
    Update = 2,
    Delete = 3
}
export class SearchFavoriteOperation {
    public SearchFavorites: SearchFavorite[];
    public ResultMessage: ResultMessage;
}
export class favPopUpModel {
    public SearchFavorite: SearchFavorite = new SearchFavorite();
    public operation: FavOperation = FavOperation.Add;

}

export class SelectedList {
    measurementPointId: number;
    measurementPointName: string;
    dealerSelected: number[]

}

export class DealerSelected {
    dealerId: number;
}

export class CompartDealerList {
    compartId: number;
    selectedObsList: SelectedList[];
}

export interface EquipmentShovelData {
    EquipmentId_Auto: number;
    SerialNo: string;
    UnitNo: string;
    ModelId: number;
    ModelDesc: string;
    Manufacturer: string;
    JobsiteId: number;
    Jobsite: string;
    Customer: string;
    MonthlyPropelPercentage: number;
    Components: ComponentForecast[];
    VisibleComponents?: ComponentForecast[];
    Status:string;
    StatusColor:string;
    RowSpan?: number;

}

export interface ComponentForecast {
    CompartType_Auto: number;
    CompartType: string;
    SOrder: number;
    Side: string;
    Part: string;
    Manufacturer: string,
    InstallDate: Date | string | null;
    LastInspectionDate: Date | string | null;
    InstallSMU: number;
    InstallPropelhours: number;
    ComponentPropelPercentage: number;
    CurrentPropelHours: number;
    CurrentCmu: number;
    DurrentPropelHours: number;
    ResidualMonthSMUBased: number;
    Track_Budget_Life: number;
    Residulalife100: number;
    EOLDateSMUDate: Date | string | null;
    AVGWornPercentage: number;
    ResidualMonthBasedOnCondition: number;
    EOLMonthBasedOnCOndition: Date | string | null;
    HourAt100Percentage: number;
    HourAt120Percentage: number;
    ForecastHourAtOutage: number;
    ForecastPercentageAtOutage: number;
    MonthlyPropelPercentage: number;
    ScheduleOutageDate: Date;
    Notes: string;
    DisplayValues?: { [key: string]: any };
    CurrentPMU:number;
    LastInspSMU:number;
    LastInspPropelHour:number;
    LastInspPropelPer:number
    
    
}
export interface DashBoardShovelShowHideColumnsName {
    CompartTypeId: number;
    CompartType: string;
    Checked: boolean;
}

export interface EquipmentForecastDataVM {
    Data: EquipmentShovelData[];
    Columns: DashBoardShovelShowHideColumnsName[];
}

export interface ComponentColumn {
    id: string;
    title: string;
    order: number;
    visible: boolean;
}
